import { ButtonBase, styled, Switch as MuiSwitch } from "@mui/material";

export const Root = styled(ButtonBase)(({ theme }) => {
  const isDark = theme.palette.mode === "dark";

  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: theme.spacing(0.75),
    padding: theme.spacing(0, 1.75, 0, 0.75),
    borderRadius: 999,
    backgroundColor: isDark ? theme.palette.grey[900] : theme.palette.grey[100],
    color: theme.palette.text.primary,
    textTransform: "none",
    flexShrink: 0,
    height: 36,
    minHeight: 36,
    boxSizing: "border-box",
    cursor: "pointer",
    userSelect: "none",

    "&:hover": {
      backgroundColor: isDark
        ? theme.palette.grey[800]
        : theme.palette.grey[200],
    },

    "&:focus-visible": {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
  };
});

export const Switch = styled(MuiSwitch)(({ theme }) => ({
  width: 28,
  height: 18,
  padding: 0,
  overflow: "visible",
  flexShrink: 0,

  "& .MuiSwitch-switchBase": {
    padding: 2,
    margin: 0,
    transitionDuration: "150ms",

    "&.Mui-checked": {
      transform: "translateX(10px)",

      "& + .MuiSwitch-track": {
        backgroundColor: `${theme.palette.text.primary} !important`,
        opacity: 1,
      },
    },
  },

  "& .MuiSwitch-thumb": {
    width: 14,
    height: 14,
    boxShadow: "none",
    backgroundColor: theme.palette.background.paper,
  },

  "& .MuiSwitch-track": {
    width: 28,
    height: 18,
    borderRadius: 999,
    opacity: 1,
    backgroundColor: `${
      theme.palette.mode === "dark"
        ? theme.palette.grey[700]
        : theme.palette.grey[400]
    } !important`,
  },
}));
